import { Icon, Spinner, Typography } from '@scale/scaleui';
import { ChatAudioEditor } from 'react-scale/components/scalers/tasks/ThreadedInteraction/attachments/audio-attachments/ChatAudioEditor';
import { AudioValidationError } from 'react-scale/components/scalers/tasks/ThreadedInteraction/attachments/audio-attachments/wavesurfer-utils';

type Props = {
  referenceAudioFileBlob: Blob | null | undefined;
  isReferenceAudioFileBlobLoading: boolean;
  isReferenceAudioFileBlobError: boolean;
  setAudioErrors: (errors: AudioValidationError[]) => void;
};

export const ReferenceAudioClip = ({
  referenceAudioFileBlob,
  isReferenceAudioFileBlobLoading,
  isReferenceAudioFileBlobError,
}: Props) => {
  if (!referenceAudioFileBlob) {
    return null;
  }

  let content = null;
  if (isReferenceAudioFileBlobLoading) {
    content = (
      <div className="flex gap-1 items-center justify-center">
        <Spinner size="xs" variant="neutral" />
        <Typography.Paragraph3>Loading reference audio clip...</Typography.Paragraph3>
      </div>
    );
  } else if (isReferenceAudioFileBlobError) {
    content = (
      <div className="flex gap-1 items-center justify-center">
        <Icon icon={['fas', 'times-circle']} variant="danger" />
        <Typography.Paragraph3 color="text-danger-500">
          Failed to load the reference audio clip
        </Typography.Paragraph3>
      </div>
    );
  } else {
    content = <ChatAudioEditor readonly originalBlob={referenceAudioFileBlob} />;
  }

  return (
    <div className="flex flex-col gap-2">
      <Typography.Overline2>Reference audio clip</Typography.Overline2>
      {content}
    </div>
  );
};
